"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stylePropTypes = exports.styleDefaultProps = exports.squareStyleProp = exports.paddingStyleProp = exports.getStyleProp = exports.buttonPropTypes = exports.buttonDefaultProps = exports.borderRadiusStyleProp = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  color: ", ";\n  cursor: ", ";\n  font-size: ", ";\n  font-family: inherit;\n  font-weight: ", ";\n  height: ", ";\n  line-height: ", ";\n  padding: ", ";\n  width: ", ";\n  \n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  \n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    outline: none;\n  }\n"], ["\n  background-color: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  border-style: ", ";\n  border-width: ", ";\n  color: ", ";\n  cursor: ", ";\n  font-size: ", ";\n  font-family: inherit;\n  font-weight: ", ";\n  height: ", ";\n  line-height: ", ";\n  padding: ", ";\n  width: ", ";\n  \n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n  \n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    outline: none;\n  }\n"]);

var _arenaConfig = require("arena-config");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("./propTypes");

var _styleProps = require("./styleProps");

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var makeButtonProps = function makeButtonProps(_ref) {
  var dispatch = _ref.dispatch,
      preventDefault = _ref.preventDefault,
      reset = _ref.reset,
      round = _ref.round,
      square = _ref.square,
      styleProps = _ref.styleProps,
      rest = _objectWithoutProperties(_ref, ["dispatch", "preventDefault", "reset", "round", "square", "styleProps"]);

  return _react2.default.createElement("button", rest);
};

var StyledButton = (0, _styledComponents2.default)(makeButtonProps)(_templateObject, (0, _styles.getStyleProp)('backgroundColor'), (0, _styles.getStyleProp)('borderColor'), (0, _arenaConfig.px)((0, _styles.borderRadiusStyleProp)()), (0, _styles.getStyleProp)('borderStyle'), (0, _arenaConfig.px)((0, _styles.getStyleProp)('borderWidth')), (0, _styles.getStyleProp)('textColor'), (0, _styles.getStyleProp)('cursor'), (0, _arenaConfig.px)((0, _styles.getStyleProp)('fontSize')), (0, _styles.getStyleProp)('fontWeight'), (0, _arenaConfig.px)((0, _styles.squareStyleProp)()), (0, _styles.getStyleProp)('lineHeight'), (0, _arenaConfig.px)((0, _styles.paddingStyleProp)()), (0, _arenaConfig.px)((0, _styles.squareStyleProp)(true)), (0, _styles.getStyleProp)('backgroundColorHover'), (0, _styles.getStyleProp)('borderColorHover'), (0, _styles.getStyleProp)('textColorHover'), (0, _styles.getStyleProp)('backgroundColorActive'), (0, _styles.getStyleProp)('borderColorActive'), (0, _styles.getStyleProp)('textColorActive'));

var Button = function Button(props) {
  var disabled = props.disabled,
      onClick = props.onClick,
      preventDefault = props.preventDefault;

  var handleClick = function handleClick(event) {
    var shouldHandleClick = !disabled && typeof onClick === 'function';
    var shouldPreventDefault = disabled || preventDefault;

    if (shouldPreventDefault) {
      event.preventDefault();
    }

    if (shouldHandleClick) {
      onClick(event);
    }
  };

  var styleProps = _extends({}, _styleProps.styleDefaultProps, props.styleProps);

  return _react2.default.createElement(StyledButton, _extends({}, props, {
    onClick: handleClick,
    styleProps: styleProps
  }));
};

Button.defaultProps = _propTypes.buttonDefaultProps;
Button.propTypes = _propTypes.buttonPropTypes;
exports.borderRadiusStyleProp = _styles.borderRadiusStyleProp;
exports.buttonDefaultProps = _propTypes.buttonDefaultProps;
exports.buttonPropTypes = _propTypes.buttonPropTypes;
exports.getStyleProp = _styles.getStyleProp;
exports.paddingStyleProp = _styles.paddingStyleProp;
exports.squareStyleProp = _styles.squareStyleProp;
exports.styleDefaultProps = _styleProps.styleDefaultProps;
exports.stylePropTypes = _styleProps.stylePropTypes;
exports.default = Button;